/*jshint globalstrict: false*/

import Vue from 'vue';
import CoffeeMap from '../components/home/coffee-map';
import axios from 'axios';

Vue.component('coffee-map', CoffeeMap);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="coffee-map-vue"]',
    });
});
